<template>
    <a-modal
    title="祺信兑付"
    v-model="modalShow"
    width="400px"
    @ok="handleOk"
    @cancel="handleCancel"
    :confirm-loading="confirmLoading"
    destroyOnClose>
        <div class="spaceCenter">
            <div class="text-center">即将付款</div>
            <div class="text-center"><user-currency :value="pymAmt" class="text-size-24 text-color-orange"></user-currency>元</div>
            <a-input v-model="pwd" style="width:210px;" type="password"/>
        </div>
        <div class="text-zh">付款账号：<user-account :account="userObj.accNo|defaultText(19)"></user-account></div>
    </a-modal>
</template>

<script>
import {mapMutations,mapGetters} from "vuex"
import {BuyerGoldcheckPayAPI} from '@/api/buyrPym.js'
import userCurrency from "@/components/user-currency/user-currency";
export default {
    props:{
        info:{
            type:[Array],
            default:function(){
                return []
            }
        }
    },
    components:{
        userCurrency
    },
    name:"gold-detail-dialog",
    data() {
        return {
            pageData:{},
            modalShow:false,
            confirmLoading:false,
            pwd:"",
            pymAmt:0
        }
    },
    computed: {
        ...mapGetters({
            userObj:"home/getUserObj",
            parentData:"app/getGoldDetailPrarms"

        }),
        
    },
    created() {
    },
    mounted() {},
    methods: {
        ...mapMutations({
            setBuyOrSell:"app/setBuyOrSell",
        }),
        getPymAmt(){
            let sum = 0;
            this.info.forEach(i => {
                sum += Number(i.pymAmt)
            })
            this.pymAmt = sum;
            return sum;
        },
        open(){
            this.modalShow = true;
        },
        close(){
            this.modalShow = false;
        },
        handleOk(){
            this.confirmLoading = true;
            let param = {
                pymPswd:this.utils.getPasswordEncryptString(this.pwd),
                pymAmt:this.pymAmt,
                gldListStr:JSON.stringify(this.info),
                pymInfSrc:'3'
            }
            BuyerGoldcheckPayAPI(param).then(res => {
                this.$message.success(res.description);
                this.close();
                this.$emit("success");
                this.confirmLoading = false;
            }).catch(err => {
                this.confirmLoading = false;
                // this.$message.error(err.description || '付款失败');
            })
        },
        handleCancel(){
            this.pwd = "";
        }
    },
    watch: {
        info:{
            handler(newVal, oldVal) {
                this.getPymAmt();
        　　},
            deep:true
        }
    },
    activated() {}
}
</script>
<style scoped>
    .text-center{
        width: 100%;
        text-align: center;
        margin-bottom:10px;
    }
    .text-zh{
        font-size: 12px;
        text-align: center;
        margin-top:10px;
    }
</style>


// WEBPACK FOOTER //
// src/pages/bill-payment/onpay-modal.vue